module.exports = __webpack_public_path__ + "img/18.36f00606.jpg";